<template>
  <div
    id="slide-8"
    class="slide mx-83 pt-68 mx-23.5 h-screen relative flex justify-between"
  >
    <div class="flex w-115 flex-col items-end gap-12.5">
      <p class="fz-301 w-115">{{ text.letsTalk }}</p>
      <p
        class=" fz-18 w-85"
        style="color: rgba(192, 197, 216, 1); line-height: 1.875rem"
      >
        {{ text.weReady }}
      </p>
      <div class=" become-client w-85">
        <div
          class="connect-content flex justify-start items-center cursor-pointer w-max"
          @click="toggleContacts"
        >
          <div class="plus w-12.5 h-12.5 rounded-full mr-5 relative">
            <div
              class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
            ></div>
            <div
              class="absolute top-1/2 left-1/2 transform rotate-90 -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
            ></div>
          </div>
          <p class="uppercase font-semibold fz-13">{{ text.become }}</p>
        </div>

        <div class="connect-grad relative" style="z-index: -1">
          <div id="grad-1"></div>
          <div id="grad-2"></div>
          <div id="grad-3"></div>
        </div>
      </div>
      <div
        class="h-px w-85 mt-12.5"
        style="background: rgba(151, 163, 203, 0.3)"
      ></div>
      <p
        class="fz-10 font-medium w-85"
        style="letter-spacing: 0.3rem; color: rgba(110, 117, 141, 1)"
      >
        {{ text.maxFrai }}
      </p>
    </div>
    <img
      src="@/assets/images/slide_7/targe.svg"
      class="w-12.5 h-12.5"
      alt=""
    />

  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide7",
  methods:{
    ...mapMutations(['toggleContacts'])
  },
  computed: {
    text() {
      return require("@/assets/text/reuseable/last/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style lang="scss" scoped>
.slide {
  width: auto !important;
}
</style>
